module.exports = __webpack_public_path__ + "img/7-4.e533a2a3.png";